/**
 * テナント基本情報 API エンドポイント定義
 *
 * GET /api/tenant/basic → useGetTenantBasicQuery()
 * PUT /api/tenant/basic → useUpdateTenantBasicMutation()
 */

import { api } from '../../store/api';

// ---------- 型定義 ----------

/** 本部設定 > 基本情報 */
export interface TenantBasicResponse {
  tenant_id: string;
  name: string;
  industry_id: number | null;
  industry_type_id: number | null;
  fiscal_start_month: number | null;
  month_start_day: number | null;
  week_start_day: number | null;
}

/** 本部設定 > 基本情報 更新リクエスト */
export interface TenantBasicUpdateRequest {
  name: string;
  industry_id: number;
  industry_type_id: number | null;
  fiscal_start_month: number;
  month_start_day: number;
  week_start_day: number;
}

// ---------- エンドポイント ----------

const tenantApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTenantBasic: builder.query<TenantBasicResponse, void>({
      query: () => '/tenant/basic',
      providesTags: ['Tenant'],
    }),
    updateTenantBasic: builder.mutation<TenantBasicResponse, TenantBasicUpdateRequest>({
      query: (body) => ({
        url: '/tenant/basic',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Tenant'],
    }),
  }),
});

export const { useGetTenantBasicQuery, useUpdateTenantBasicMutation } = tenantApi;
